import apiClient from './api';

const base = (restaurantId, locationId) =>
  `/users/restaurant/${restaurantId}/locations/${locationId}/floor-plan/`;

export const floorPlanService = {
  get: async (restaurantId, locationId) => {
    const { data } = await apiClient.get(base(restaurantId, locationId));
    return data?.data;
  },
  save: async (restaurantId, locationId, plan) => {
    // plan: { floors: [...] } — see backend controller for full schema
    const { data } = await apiClient.put(`${base(restaurantId, locationId)}save/`, plan);
    return data?.data;
  },
};
